import React from 'react';

// Generic status pill, reused for both independent order fields:
// fulfillment status (pending, processing, shipped, ready_for_pickup,
// picked_up, completed, cancelled, refunded) and paymentStatus (pending,
// balance_due, paid).
// Color mapping lives in checkout.css (.ss-status--*).
export default function OrderStatusBadge({ status }) {
  const s = (status || 'pending').toLowerCase();
  return <span className={`ss-status ss-status--${s}`}>{s.replace(/_/g, ' ')}</span>;
}
